// 启动模块服务层

import utils from "../../../utils";
import { startupApi } from "../api";
import { StartupData } from "../types";

// 启动服务类
export class StartupService {
  private static instance: StartupService;

  static getInstance(): StartupService {
    if (!StartupService.instance) {
      StartupService.instance = new StartupService();
    }
    return StartupService.instance;
  }
  //保存本地存储
  saveLocalStorage(data: StartupData) {
    if (utils.hasProperty(data, "currencyId")) {
      utils.setObject("currencyId", data.currencyId);
    }
    if (utils.hasProperty(data, "autoBk")) {
      utils.setObject("autoBk", data.autoBk);
    }
    if (utils.hasProperty(data, "enableRegisterPromoCode")) {
      utils.setObject("enableRegisterPromoCode", data.enableRegisterPromoCode);
    }
  }
  // 启动数据服务
  async loadStartupData(lazy: boolean = true): Promise<StartupData> {
    try {
      const data = await startupApi.getStartupData(lazy);
      this.saveLocalStorage(data);
      return data;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "启动数据加载失败";
      throw new Error(errorMessage);
    }
  }

  // 清理启动数据缓存
  clearStartupCache(): void {
    console.log("清理启动数据缓存");
  }
}

// 创建单例实例
export const startupService = StartupService.getInstance();

// 导出便捷方法
export const { loadStartupData, clearStartupCache } = startupService;
